import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "raffleManageFill" }

import {basicFormConfig} from "./config/form.config";
import {reactive, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Fill',
  setup(__props) {

const closePage = () => {
  window.close()
}

const defaultInfo = ref({})

const otherInfo = reactive({})

const handleValid = () => {
}


return (_ctx: any,_cache: any) => {
  const _component_BasicForm = _resolveComponent("BasicForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BasicForm, {
      basicFormConfig: _unref(basicFormConfig),
      "col-layout": {xl: 12,lg: 12,md: 12,sm: 12,xs: 12},
      pageName: "raffleManage",
      onClosePage: closePage
    }, null, 8, ["basicFormConfig"])
  ]))
}
}

})